var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AButton',{attrs:{"type":_vm.type,"size":_vm.size,"icon":_vm.icon},on:{"click":_vm.backMainPage}},[_vm._v(_vm._s(_vm.btnText))])}
var staticRenderFns = []

export { render, staticRenderFns }